import { EUnitNoOfRoom } from '../enums/unit.enum';
import { OptionDescription } from './option.type';

export type UnitNoOfRoomTypeRecord = Record<EUnitNoOfRoom, OptionDescription<EUnitNoOfRoom>>;
